import * as setup from '@/setup';
import * as Constants from '@/constants';
import Button from '@/objects/button';
import { drawGameOverScene } from '@/gui/game-over-scene.js';
import runtime from '@/runtime';
import * as config from '@/config-APP_TARGET';
import axios from 'axios';
import EventDispatcher from '@/utils/events';
import * as audio from '@/utils/audio';
export default class GameOver extends Phaser.Scene {
	/**
	 *  The GameOver scene
	 *
	 *  @extends Phaser.Scene
	 */
	constructor() {
		super({key: 'GameOver'});
		this.buttonPlay = null;
		this.buttonQuit = null;
		this.buttonChallenge = null;
		this.finalScoreText = null;
		this.creditsEarnedText = null;
		this.creditsEarnedIcon = null;
		this.roundSaved = false; // Flag per evitare salvataggi multipli
	}

	create() {
		console.log('gameOver scene created');
		console.log('gameOver scene settings', this.scene.settings.data);
		console.log('gameOver scene registry', this.registry.values);
		
		// Reset flag per nuovo round
		this.roundSaved = false;
		
		this.emitter = EventDispatcher.getInstance();
		console.log('emitter', this.emitter);
		if (this.scene.settings.data.round !== Constants.ROUND_END) {
			//round in pausa. Da implementare se serve
			return;
		}

		let icon = null;
		let initialScore = this.registry.values.score;
		// time è già in secondi (non in millisecondi)
		let timeRemaining = this.registry.values.time || 0;
		
		// Verifica se sono stati usati aiuti per ridurre il bonus tempo
		let gameScene = this.scene.get('Game');
		let powersUsed = gameScene && gameScene._powersUsed === true;
		// Se sono stati usati aiuti, riduci il bonus tempo al 50%
		let timeBonus = powersUsed ? timeRemaining * 0.5 : timeRemaining;
		// Arrotonda il punteggio finale a intero per evitare errori di validazione nel backend
		let finalScore = Math.round(initialScore + timeBonus);
		console.log('GameOver - initialScore:', initialScore, 'timeRemaining:', timeRemaining, 'powersUsed:', powersUsed, 'timeBonus:', timeBonus, 'finalScore:', finalScore);

		if (this.scene.settings.data.status === Constants.ROUND_STATUS_WON) {
			// round vinto - mostra direttamente il punteggio finale
			icon = 'game-over-background-win';
			
			// Suono vittoria
			audio.playSound(this, 'game-win');
			
			let solutionText = runtime.dict.title + ' di ' + runtime.dict.author;
			let {buttonPlay, buttonQuit} = drawGameOverScene(this, icon, solutionText);
			this.buttonPlay = buttonPlay;
			this.buttonQuit = buttonQuit;

			// Mostra direttamente il punteggio finale
			this.showFinalScore(finalScore);
			
			// Aggiungi pulsante "Sfida un amico"
			this.addChallengeButton();
			
		} else {
			// round perso - mostra solo il punteggio
			// Suono sconfitta
			audio.playSound(this, 'game-lose');
			
			let textLabel = setup.labels.lost + initialScore;
			icon = 'game-over-background-lost';
			let {buttonPlay, buttonQuit} = drawGameOverScene(this, icon, textLabel);
			this.buttonPlay = buttonPlay;
			this.buttonQuit = buttonQuit;
		}

		// chiudo il round e salvo nel db in locale e remoto
		// IMPORTANTE: Assicurati che lo status sia STATUS_CLOSED (30)
		// Invia tutti i campi richiesti per la validazione (game_id, dict_id, user_id, status)
		let isWon = this.scene.settings.data.status === Constants.ROUND_STATUS_WON;
		
		// Calcola time_used (tempo usato in millisecondi per il backend)
		// NOTA: runtime.round.time_used è il tempo RIMASTO in secondi
		// Il backend si aspetta time_used come tempo USATO in millisecondi
		let timeUsed = null;
		if (runtime.round.time_used !== null && runtime.round.time_used !== undefined) {
			// runtime.round.time_used è il tempo rimasto in secondi
			// Calcola il tempo usato: available_time - time_remaining
			let timeRemainingSeconds = runtime.round.time_used;
			let availableTimeSeconds = runtime.mode.available_time;
			let timeUsedSeconds = availableTimeSeconds - timeRemainingSeconds;
			// Converti in millisecondi per il backend
			timeUsed = Math.max(0, timeUsedSeconds * 1000);
		} else if (timeRemaining !== null && timeRemaining !== undefined) {
			// Fallback: usa timeRemaining se time_used non è disponibile
			let availableTimeSeconds = runtime.mode.available_time;
			let timeUsedSeconds = availableTimeSeconds - timeRemaining;
			timeUsed = Math.max(0, timeUsedSeconds * 1000);
		}
		
		// Calcola crediti spesi durante il round
		let creditsSpent = runtime._creditsSpentThisRound || 0;
		console.log('GameOver - creditsSpent:', creditsSpent);
		
		// Ottieni il dettaglio degli aiuti usati
		let helpsUsed = runtime._helpsUsedThisRound || {};
		console.log('GameOver - helpsUsed:', helpsUsed);
		
		let roundToSave = {
			game_id: runtime.round.game_id,
			dict_id: runtime.round.dict_id,
			user_id: runtime.round.user_id,
			status: runtime.constants.round.STATUS_CLOSED, // 30
			score: finalScore,
			won: isWon,
			time_used: timeUsed,
			current_solved_letters: runtime.round.current_solved_letters,
			missed_letters: runtime.round.missed_letters,
			credits_spent: creditsSpent, // Crediti usati per gli aiuti
			// Dati per round_result
			letter_points: initialScore, // Punti guadagnati con le sole lettere
			time_remaining: timeRemaining, // Tempo rimasto in secondi
			helps_used: helpsUsed // Dettaglio aiuti utilizzati per tipo
		};
		// Evita salvataggi multipli dello stesso round
		if (this.roundSaved) {
			console.log('Round già salvato, skip salvataggio');
			return;
		}
		this.roundSaved = true;
		
		console.log('Sto per salvare il round come STATUS_CLOSED', {
			round_id: runtime.round.id,
			status: roundToSave.status,
			score: roundToSave.score,
			STATUS_CLOSED: runtime.constants.round.STATUS_CLOSED,
			all_fields: roundToSave
		});
		axios.put(`/api/rounds/${runtime.round.id}`,
			roundToSave
			).then(function (response) {
			// handle success
			console.log('Round salvato con successo come STATUS_CLOSED', {
				round_id: response.data.id,
				status: response.data.status,
				score: response.data.score,
				credits_earned: response.data.credits_earned,
				round_result: response.data.round_result
			});

			// Log per debug
			console.log('Round salvato - credits_earned:', response.data.credits_earned, 
				'credits_spent:', response.data.credits_spent, 
				'net_credits:', response.data.net_credits,
				'round_result:', response.data.round_result);
			
			// Mostra solo i crediti guadagnati (non il bilancio netto)
			if (response.data.credits_earned !== undefined && response.data.credits_earned > 0) {
				this.time.delayedCall(1600, () => {
					this.showCreditsEarned(response.data.credits_earned);
				});
			}

			// Se l'utente ha avanzato di skill, mostra l'animazione
			if (response.data.skill_advanced && response.data.new_skill) {
				this.time.delayedCall(2500, () => {
					this.showSkillAdvancement(response.data.new_skill);
				});
			}

		}.bind(this)).catch(function (error) {
			// handle error
			console.error('Errore nel salvataggio del round', error);
			if (error.response && error.response.data) {
				console.error('Dettagli errore:', error.response.data);
				console.error('Status code:', error.response.status);
				console.error('Round data inviato:', roundToSave);
			} else {
				console.error('Errore di rete o altro:', error.message);
			}
			// Mostra un messaggio all'utente se possibile
			if (this.showMessageBox) {
				this.showMessageBox('Errore nel salvataggio del round. Riprova più tardi.', this.game.width * .7, this.game.height * .5);
			}
		}.bind(this));

		/****************************************************************
		 *
		 * EVENTO BOTTONE PLAY
		 *
		 ***************************************************************/
		this.buttonPlay.once(
			'pointerup',
			function () {
				this.cameras.main.fade(250);
				// restart game
				this.time.delayedCall(
					500,
					function () {
						console.log('emit newGame event');
						this.emitter.emit('newGame');
					},
					[],
					this
					);
			},
			this
			);

		/****************************************************************
		 *
		 * EVENTO INIZIA NUOVA PARTITA
		 *
		 ***************************************************************/
		this.emitter.once(
			'newGame',
			function () {
				console.log('got newGame event', this.game);
				//this.scene.manager.bootScene(this);

				// fermo la scena del gioco (era in parallelo, ma con eventi spenti per far vedere lo sfondo)
				let gameScene = this.scene.get('Game');
				gameScene.registry.destroy();
				gameScene.scene.stop('Game');

				//gameScene.events.off();
				this.emitter.off('playPower');
				this.emitter.off('playOneLetter');

				// spengo gli eventi del boot riavvio la scena del boot
				let bootScene = this.scene.get('Boot');
				//bootScene.events.off();
				this.scene.manager.bootScene(bootScene);

				// shutdown della scena GameOver
				this.registry.destroy();
				//this.events.off();
				this.scene.stop();
			},
			this
			);

		/****************************************************************
		 *
		 * EVENTO BOTTONE QUIT (Menù)
		 *
		 ***************************************************************/
		this.buttonQuit.once(
			'pointerup',
			function () {
				console.log('Menù - tornando al menu principale', this);
				
				// Disabilita il bottone per evitare doppi click
				this.buttonQuit.setInteractive(false);
				
				// Ferma la scena del gioco
				let gameScene = this.scene.get('Game');
				if (gameScene) {
					gameScene.registry.destroy();
					gameScene.scene.stop('Game');
				}
				
				// Spegni gli eventi
				this.emitter.off('playPower');
				this.emitter.off('playOneLetter');
				
				// Reset del flag gameInProgress
				runtime.gameInProgress = false;
				
				// Vai al menu principale
				this.scene.start('MainMenu');
				
				// Shutdown della scena GameOver
				this.registry.destroy();
				this.scene.stop();
			},
			this
			);
	}

	showFinalScore(finalScore) {
		const centerX = this.sys.game.config.width / 2;
		const centerY = this.sys.game.config.height / 2;

		// Colore blu #1567a3
		const blueColor = '#1567a3';
		const blueColorHex = 0x1567a3;

		// Mostra il punteggio iniziale
		const initialScore = this.registry.values.score;
		this.finalScoreText = this.add.text(
			centerX,
			centerY - 20,
			`Punteggio: ${initialScore}`,
			{...setup.styles.gameOver.greetingStyle, fontSize: 32, fill: blueColor}
		).setOrigin(0.5);

		// Crea barra di progresso animata per il punteggio
		if (finalScore > initialScore) {
			const barWidth = 300;
			const barHeight = 20;
			const barX = centerX - barWidth / 2;
			const barY = centerY + 20;

			// Sfondo della barra (grigio)
			const barBg = this.add.graphics();
			barBg.fillStyle(0xCCCCCC, 1);
			barBg.fillRoundedRect(barX, barY, barWidth, barHeight, 10);

			// Barra di progresso (blu #1567a3)
			const progressBar = this.add.graphics();
			progressBar.fillStyle(blueColorHex, 1);

			// Anima il punteggio e la barra di progresso
			this.tweens.addCounter({
				from: initialScore,
				to: finalScore,
				duration: 1500,
				onUpdate: (tween) => {
					const currentScore = Math.floor(tween.getValue());
					this.finalScoreText.setText(`Punteggio: ${currentScore}`);
					
					// Aggiorna la barra di progresso
					const progress = (currentScore - initialScore) / (finalScore - initialScore);
					progressBar.clear();
					progressBar.fillStyle(blueColorHex, 1);
					progressBar.fillRoundedRect(barX, barY, barWidth * progress, barHeight, 10);
				},
				onComplete: () => {
					this.finalScoreText.setText(`Punteggio finale: ${finalScore}`);
					// Assicura che la barra sia completa
					progressBar.clear();
					progressBar.fillStyle(blueColorHex, 1);
					progressBar.fillRoundedRect(barX, barY, barWidth, barHeight, 10);
				}
			});
		}
	}

	showCreditsEarned(creditsEarned) {
		const centerX = this.sys.game.config.width / 2;
		const centerY = this.sys.game.config.height / 2;
		
		// Posiziona il testo dei crediti guadagnati sotto la barra di progresso
		// La barra è a centerY + 20, con altezza 20px, quindi il bordo inferiore è a centerY + 40
		// L'animazione sposta il testo a creditsY - 10, quindi dobbiamo partire da una posizione più bassa
		// Spostiamo i crediti almeno 30 pixel più in basso: centerY + 100
		const creditsY = centerY + 100;
		
		// Crea l'icona del fulmine
		this.creditsEarnedIcon = this.add.image(0, 0, 'power-icon');
		this.creditsEarnedIcon.setScale(0.3);
		this.creditsEarnedIcon.setAlpha(0);
		
		// Crea il testo con animazione - ridotto il font size per non uscire dal popup
		this.creditsEarnedText = this.add.text(
			0,
			creditsY,
			`+${creditsEarned} aiuti guadagnati!`,
			{
				...setup.styles.gameOver.greetingStyle,
				fontSize: 24,
				fill: '#FFD700'
			}
		).setOrigin(0.5).setAlpha(0);
		
		// Posiziona icona e testo insieme
		const totalWidth = this.creditsEarnedIcon.displayWidth + 10 + this.creditsEarnedText.width;
		this.creditsEarnedIcon.x = centerX - totalWidth / 2 + this.creditsEarnedIcon.displayWidth / 2;
		this.creditsEarnedIcon.y = creditsY;
		this.creditsEarnedText.x = centerX + totalWidth / 2 - this.creditsEarnedText.width / 2;
		
		// Animazione di entrata per icona e testo
		this.tweens.add({
			targets: [this.creditsEarnedIcon, this.creditsEarnedText],
			alpha: 1,
			y: creditsY - 10,
			duration: 500,
			ease: 'Power2',
			onComplete: () => {
				// Animazione di "bounce" per attirare l'attenzione
				this.tweens.add({
					targets: [this.creditsEarnedIcon, this.creditsEarnedText],
					scaleX: 1.2,
					scaleY: 1.2,
					duration: 200,
					yoyo: true,
					repeat: 1,
					ease: 'Power2'
				});
			}
		});
		
		console.log(`Crediti guadagnati: ${creditsEarned}, Nuovo totale: ${runtime.ranking.available_credits}`);
	}

	/**
	 * Mostra l'animazione di avanzamento skill
	 * @param {Object} newSkill Oggetto con i dati del nuovo skill (id, name, level, description)
	 */
	showSkillAdvancement(newSkill) {
		var centerX = this.cameras.main.width / 2;
		var centerY = this.cameras.main.height / 2;

		// Overlay scuro semi-trasparente
		var overlay = this.add.rectangle(centerX, centerY,
			this.cameras.main.width, this.cameras.main.height, 0x000000, 0.7);
		overlay.setAlpha(0);

		// Icona (usiamo score-icon disponibile)
		var icon = this.add.image(centerX, centerY - 80, 'score-icon');
		icon.setScale(0);
		icon.setAlpha(0);

		// Testo "+1 Livello"
		var levelUpText = this.add.text(centerX, centerY, '+1 Livello', {
			fontSize: '48px',
			fontFamily: 'Arial',
			color: '#FFD700',
			fontStyle: 'bold'
		});
		levelUpText.setOrigin(0.5);
		levelUpText.setAlpha(0);

		// Titolo dello skill
		var skillTitle = this.add.text(centerX, centerY + 60, newSkill.name, {
			fontSize: '32px',
			fontFamily: 'Arial',
			color: '#FFFFFF',
			fontStyle: 'bold'
		});
		skillTitle.setOrigin(0.5);
		skillTitle.setAlpha(0);

		// Descrizione dello skill
		var skillDesc = this.add.text(centerX, centerY + 110, newSkill.description, {
			fontSize: '18px',
			fontFamily: 'Arial',
			color: '#CCCCCC',
			wordWrap: { width: 300 }
		});
		skillDesc.setOrigin(0.5);
		skillDesc.setAlpha(0);

		// Riprodurre audio
		audio.playSound(this, 'skill-gain');

		// Riferimento a this per le callback annidate
		var self = this;

		// Animazione sequenziale
		// 1. Fade in overlay
		this.tweens.add({
			targets: overlay,
			alpha: 1,
			duration: 300,
			onComplete: function() {
				// 2. Icona appare con effetto zoom + rotazione
				self.tweens.add({
					targets: icon,
					alpha: 1,
					scale: 0.5,
					angle: 360,
					duration: 600,
					ease: 'Back.easeOut',
					onComplete: function() {
						// 3. Bounce dell'icona
						self.tweens.add({
							targets: icon,
							scale: 0.4,
							duration: 200,
							yoyo: true,
							repeat: 2
						});

						// 4. Testo "+1 Livello" appare
						self.tweens.add({
							targets: levelUpText,
							alpha: 1,
							y: centerY - 20,
							duration: 400,
							ease: 'Power2'
						});

						// 5. Titolo e descrizione appaiono
						self.time.delayedCall(500, function() {
							self.tweens.add({
								targets: [skillTitle, skillDesc],
								alpha: 1,
								duration: 500,
								ease: 'Power2'
							});
						});

						// 6. Fade out dopo 3 secondi
						self.time.delayedCall(3000, function() {
							self.tweens.add({
								targets: [overlay, icon, levelUpText, skillTitle, skillDesc],
								alpha: 0,
								duration: 500,
								onComplete: function() {
									overlay.destroy();
									icon.destroy();
									levelUpText.destroy();
									skillTitle.destroy();
									skillDesc.destroy();
								}
							});
						});
					}
				});
			}
		});

		console.log('Avanzamento skill mostrato:', newSkill);
	}

	addChallengeButton() {
		const centerX = this.sys.game.config.width / 2;
		const centerY = this.sys.game.config.height / 2;

		// Verifica se questo round fa parte di una sfida
		const isChallenge = runtime.currentChallenge !== null && runtime.currentChallenge !== undefined;
		const buttonText = isChallenge ? 'Esito sfida' : 'Sfida un amico';

		// Calcola la larghezza totale dei bottoni Play e Quit più lo spazio tra loro
		// Play è a width / 2.8, Quit è a width / 1.6
		const playX = this.sys.game.config.width / 2.8;
		const quitX = this.sys.game.config.width / 1.6;

		// Crea un bottone temporaneo per misurare la larghezza effettiva con scale 0.4
		const tempButton = new Button(
			this,
			0,
			-1000, // Posizionato fuori schermo
			'green-button',
			0.4,
			'Test',
			false
		);
		const singleButtonWidth = tempButton.list[0].displayWidth; // Larghezza del bottone con scale 0.4
		tempButton.destroy(); // Rimuovi il bottone temporaneo

		// Calcola la larghezza totale: distanza tra i bordi esterni dei due bottoni
		// Bordo sinistro Play: playX - singleButtonWidth/2
		// Bordo destro Quit: quitX + singleButtonWidth/2
		// Larghezza totale = (quitX + singleButtonWidth/2) - (playX - singleButtonWidth/2)
		// = quitX - playX + singleButtonWidth
		const totalWidth = (quitX - playX) + singleButtonWidth;

		// Calcola lo scale necessario per avere la stessa larghezza
		// La larghezza base dell'immagine è singleButtonWidth / 0.4
		const buttonBaseWidth = singleButtonWidth / 0.4;
		const buttonScale = totalWidth / buttonBaseWidth;

		// Posiziona il pulsante DOPO i bottoni Play e Quit, più in basso
		// I bottoni Play/Quit sono ora a: height / 2 + setup.margin.buttonPlayMarginTop + 180 - 10
		// = height / 2 + 70 + 180 - 10 = height / 2 + 240
		// Il bottone "Sfida un amico" va più in basso, a centerY + 330 + 10% = centerY + 363
		const buttonY = centerY + 330 + (330 * 0.1); // +10% più in basso

		// Sposta il bottone leggermente a sinistra (meno di prima)
		const buttonX = centerX - 5; // Spostato solo 5 pixel a sinistra invece di 15

		// Crea il bottone ma inizialmente invisibile
		this.buttonChallenge = new Button(
			this,
			buttonX,
			buttonY,
			'blue-button',
			buttonScale,
			buttonText,
			false
		);
		this.buttonChallenge.setAlpha(0);

		// Mostra il bottone dopo un breve delay per permettere all'animazione del punteggio di completarsi
		this.time.delayedCall(500, () => {
			this.tweens.add({
				targets: this.buttonChallenge,
				alpha: 1,
				duration: 500,
				ease: 'Power2'
			});
		});

		this.buttonChallenge.on('pointerup', () => {
			console.log(isChallenge ? 'Esito sfida cliccato' : 'Sfida un amico cliccato');

			// Ferma e pulisce la scena del gioco (come fanno i bottoni Play e Quit)
			let gameScene = this.scene.get('Game');
			if (gameScene) {
				gameScene.registry.destroy();
				gameScene.scene.stop('Game');
			}

			// Spegni gli eventi
			this.emitter.off('playPower');
			this.emitter.off('playOneLetter');

			// Reset del flag gameInProgress
			runtime.gameInProgress = false;

			// Shutdown della scena GameOver
			this.registry.destroy();

			if (isChallenge) {
				// Round di sfida: carica i dati aggiornati dalla API e vai al dettaglio
				console.log('Carico dati sfida aggiornati per invite:', runtime.currentChallenge.id);
				const inviteId = runtime.currentChallenge.id;
				// Reset currentChallenge
				runtime.currentChallenge = null;

				// Chiama l'API per ottenere i risultati aggiornati della sfida
				axios.get(`/api/invites/${inviteId}/result`)
					.then((response) => {
						console.log('Dati sfida caricati:', response.data);
						this.scene.start('ChallengeDetail', {
							challenge: response.data.invite,
							result: response.data.result,
							isSentChallenge: false // La sfida era ricevuta
						});
						this.scene.stop();
					})
					.catch((error) => {
						console.error('Errore caricamento dati sfida:', error);
						// Se c'è un errore (es. round non ancora salvato), torna alla lista sfide
						this.scene.start('Challenge');
						this.scene.stop();
					});
			} else {
				// Round normale: vai alla selezione sfida
				console.log('Round ID da usare per la sfida:', runtime.round.id);
				// Salva il round_id completato nel runtime per passarlo alla scena di selezione
				runtime.challengeRoundId = runtime.round.id;
				// Aspetta un breve momento per assicurarsi che il salvataggio sia partito
				this.time.delayedCall(100, () => {
					this.scene.start('ChallengeSelection');
					this.scene.stop();
				});
			}
		});
	}
}
